import { useTranslate } from '@tolgee/react'
import { useExceptionMessageHandler } from '@yard/utils/useExceptionMessageHandler'

export const useAllocationRuleTemplateMessageHandler = () => {
  const { t } = useTranslate()
  const { getExceptionMessage } = useExceptionMessageHandler()

  const getSuccessMessage = (isEditing: boolean) => {
    return isEditing
      ? t(
          'allocationRuleTemplateUpdatedSuccesfully',
          'Allocation rule template updated successfully',
        )
      : t(
          'allocationRuleTemplateCreatedSuccesfully',
          'Allocation rule template created successfully',
        )
  }

  const getDeleteSuccessMessage = () => {
    return t(
      'allocationRuleTemplateDeletedSuccesfully',
      'Allocation rule template deleted successfully',
    )
  }

  return {
    getExceptionMessage,
    getSuccessMessage,
    getDeleteSuccessMessage,
  }
}
